import { Box, Typography } from '@mui/material';
import { getLoanFlowType } from 'app/pages/loan/api/loanService';
import { LoanApplicationProvider } from 'app/pages/loan/model/context';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import BackIcon from '../../../../components/Icons/BackIcon';
import YeloLogo from '../../../../components/Icons/YeloLogo';
import Stepper from '../../../../components/Stepper/Stepper';
import { useCustomNavigate } from '../../../../utils/customHooks/useCustomNavigate';

const steps = [
  { number: 1, label: 'Kredit detalları', path: 'details' },
  { number: 2, label: 'Şəxsi məlumatlar', path: 'identity' },
  { number: 3, label: 'Sənədlərin yüklənməsi', path: 'documents' },
  { number: 4, label: 'Müraciətin təsdiqlənməsi', path: 'confirmation' },
];

export const LoanBaseLayout = () => {
  return (
    <LoanApplicationProvider>
      <Box sx={{ padding: 2, backgroundColor: '#F9FAFB', height: '100vh' }}>
        <Header />
        <Outlet />
      </Box>
    </LoanApplicationProvider>
  );
};

export const LoanStepsLayout = () => {
  const { pathname } = useLocation();
  const currentSegment = pathname.split('/').filter(Boolean).at(-1);
  const currentStep = steps.find(s => s.path === currentSegment)?.number ?? 1;

  return (
    <Container>
      <Stepper steps={steps} currentStep={currentStep} sx={{ justifyContent: 'space-between' }} />
      <Outlet />
    </Container>
  );
};

const Header = () => {
  const navigate = useCustomNavigate();

  const handleLogoClick = (event: React.MouseEvent) => {
    event.preventDefault();
    navigate('');
  };

  return (
    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
      <a onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <YeloLogo />
      </a>
    </Box>
  );
};

const Container = ({ children }: { children: React.ReactNode }) => {
  const navigate = useCustomNavigate();
  const [searchParams] = useSearchParams();
  const businessKey = searchParams.get('business_key');

  const handleBack = () => {
    const flow = getLoanFlowType();
    const base = flow === 'request_loan' ? 'loan' : 'unregistered/loan/overview-guest';
    navigate(businessKey ? `${base}?business_key=${businessKey}` : base);
  };

  return (
    <Box width={'85%'} margin={'0 auto'} display={'flex'} flexDirection={'column'} gap={4}>
      <a
        onClick={handleBack}
        style={{ height: 56, display: 'flex', gap: 2, alignItems: 'center', cursor: 'pointer' }}
        color='inherit'
      >
        <BackIcon sx={{ cursor: 'pointer' }} />
        <Typography fontWeight={600}>Biznes krediti üçün müraciət</Typography>
      </a>
      <Box
        sx={{
          borderRadius: 1,
          backgroundColor: '#FFFFFF',
          padding: 2,
          minHeight: '70vh',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
